import StorageUtils from '@/utils/StorageUtils'
import http from '@/utils/Http'
import router from '@/router'
import {isVibrate, validateEmail} from '@/utils/Utils'

const defaultConfig = {
    running: false,
    messages: []
};
const searchState = () => {
    return {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
    }
};

const BASE_PATH = '/v1/users';

export default {
    namespaced: true,
    state: {
        userSession: StorageUtils.getUser() || {},
        authToken: StorageUtils.getAuthToken(),
        login: defaultConfig,
        forgotPassword: defaultConfig,
        search: searchState(),
        profiles: {}
    },
    getters: {
        userSession: state => state.userSession,
        getLoginState(state) {
            return state.login;
        },
        getForgetPassState(state) {
            return state.forgotPassword;
        },
        authToken: state => state.authToken,
        hasLogged: state => !!state.authToken,
        search: (state) => state.search,
        profiles: (state) => state.profiles,
    },
    mutations: {
        setUser(state, payload) {
            state.userSession = payload || {};
            if (payload === null) StorageUtils.destroyUser();
            else StorageUtils.saveUser(payload);
        },
        setAuthToken(state, payload) {
            state.authToken = payload;
            if (!payload) StorageUtils.destroyAuthToken();
            else StorageUtils.saveAuthToken(payload);
        },
        releaseState(state) {
            state.login = {running: false, messages: []};
            state.forgotPassword = {running: false, messages: []};
        },
        setLogin(state, payload) {
            state.login = payload;
        },
        setSearch(state, payload) {
            state.search = payload;
        },
        setProfiles(state, payload) {
            state.profiles = payload;
        }
    },
    actions: {
        async login({commit, state}, payload) {
            commit('setLogin', defaultConfig);

            if (!payload) return;

            if (!validateEmail(payload.email || '')) {
                commit('setLogin', {...state.login, ...{messages: [{type: 'error', msg: 'E-mail inválido'}]}});
            } else if((payload.password || '').trim().length < 8) {
                commit('setLogin', {...state.login, ...{messages: [{type: 'error', msg: 'Campo senha deve ter 8 ou mais caracteres'}]}});
            } else {
                commit('setLogin', {...state.login, running: true});

                setTimeout(() => {
                    http.post('/v1/session/authenticate', payload)
                        .then(({data}) => {
                            commit('setUser', data.user);
                            commit('setAuthToken', data.auth_token);

                            const redir = router.currentRoute.query.redirect;
                            if (redir) router.push(redir);
                            else {
                                router.push(data.user.profile === 'backoffice' ? 'financial_movements' : 'dashboard');
                            }
                        })
                        .catch(err => {

                            if (isVibrate()) navigator.vibrate(200);
                            const {load_recaptcha} = (err && err.response ? err.response.data : {});
                            commit('setLogin', {...state.login, ...{messages: [{type: 'error', msg: 'Nome de usuário e/ou senha inválido(s)', load_recaptcha: load_recaptcha}]}});
                        })
                        .finally(() => {
                            commit('setLogin', {...state.login, running: false});
                        });
                }, 1000);
            }
        },
        async releaseState({commit}) {
            commit('releaseState');
        },
        async logout({commit}) {
            commit('setAuthToken', null);
            setTimeout(() => router.push('/login'), 500);
        },
        async forgot({commit, state}, email) {
            state.forgotPassword.messages = [];

            if (!validateEmail(email || '')) {
                state.forgotPassword.messages.push({type: 'error', msg: 'E-mail inválido'})
            } else {
                state.forgotPassword.running = true;
                http.post('/v1/session/forgot_password', {email: email})
                    .then(() => {
                        state.forgotPassword.messages.push({type: 'success', msg: 'Se você informou um e-mail correto, em breve receberá uma nova senha'});
                        state.forgotPassword.running = false;
                    })
                    .catch(err => {
                        state.forgotPassword.running = false;
                        if (isVibrate()) navigator.vibrate(200);
                        state.forgotPassword.messages.push({type: 'error', msg: 'Ops... Aconteceu algum problema no envio. Tente novamente'});
                        console.error(err);
                    });
            }
        },
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                http.loadEntries(path)
                    .then(data => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return http.loadEntries(path);
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadProfiles({commit}) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/load_profiles`)
                    .then(({data}) => {
                        commit('setProfiles', data);
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async resetSearch({commit}, defaultValues = {}) {
            commit('resetSearch', defaultValues);
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            return new Promise((resolve, reject) => {
                if(payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {user: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                } else {
                    http.post(BASE_PATH, {user: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                }
            })
        },
        async updateProfile({commit}, payload) {
            return new Promise((resolve, reject) => {
                http.put(`${BASE_PATH}/update_profile`, {user: payload})
                    .then(({data}) => resolve(data))
                    .catch(err => reject(err));
            })
        },
        async updateFcmToken({commit, state}, token) {
            return new Promise((resolve, reject) => {
                http.put(`${BASE_PATH}/update_fcm_token`, {user: {fcm_token: token}})
                    .then(({data}) => {
                        if (state.userSession && state.userSession.id) {
                            const newUser = {...state.userSession, fcm_token: token};
                            commit('setUser', newUser)
                        }
                        resolve(data);
                    })
                    .catch(err => reject(err));
            })
        }
    }
}
